export interface ProjectSettings {
    collectData: boolean
    familyNumberFormat: FamilyNumberFormat
    unitOfMeasure: UnitsOfMeasure
    elementTreeView?: ElementTreeView
}

export enum ElementTreeView {
    DIVISIONS = 'Divisions',
    ASSEMBLIES = 'Assemblies',
}

export enum FamilyNumberFormat {
    XXXXXX = 'XXXXXX',
    XX_XX_XX = 'XX XX XX',
    XX_XXXX = 'XX XXXX',
}

export enum UnitsOfMeasureKey {
    IMPERIAL = 'IMPERIAL',
    METRIC = 'METRIC',
    BOTH = 'BOTH',
}

export enum UnitsOfMeasure {
    IMPERIAL = 'Imperial (Default)',
    METRIC = 'Metric',
    BOTH = 'Both',
}

export interface ProjectSettingsInput {
    collectData: boolean
    familyNumberFormat: FamilyNumberFormat
    unitOfMeasure: UnitsOfMeasure
    elementTreeView?: ElementTreeView
    projectId: string
}

export interface UpdateProjectSettingsResponse {
    projectSettings: ProjectSettingsInput
}
